import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ValidationDialog: React.FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="agent-advanced-settings-validation-title"
      aria-describedby="agent-advanced-settings-validation-description">
      <DialogTitle id="agent-advanced-settings-validation-title">
        {t('adminMainPage.agent.advancedSettingsTabs.validationDialogTitle')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="agent-advanced-settings-validation-description">
          {t('adminMainPage.agent.advancedSettingsTabs.validationDialogDescription')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>
          {t('adminMainPage.agent.advancedSettingsTabs.validationDialogConfirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
